export class CloseContent {
  constructor() {
    this.DOM = {};
    this.DOM.target = document.querySelectorAll('.js-target');
    this.DOM.targetClose = document.querySelectorAll('.js-targetClose');

    if (!this.DOM.targetClose) return;

    this.onInit();
  }
  /**
   * 初期化
   */
  onInit() {
    this.DOM.targetClose.forEach(element => {
      element.addEventListener('click',function(e) {
        this.closest('.js-target').classList.add('is-hidden');
      });
    });
  }
}
